import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

export const CURRENCY_NAMES = new InjectionToken<Observable<Record<string, string>>>(
  'CURRENCY_NAMES',
);
